// Module
var code = `<div ng-click="\$ctrl.goBack()">
	<i class="fas fa-angle-left"></i>
	<span ng-if="\$ctrl.title" style="margin-left: 5px;">{{::\$ctrl.title}}</span>
</div>
`;
// Exports
export default code;